// import { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { API } from "../../../examples/config";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchApiData } from "../../../features/account/accountthunk";
// import MD5 from "crypto-js/md5";
// import { v4 as uuidv4 } from "uuid";
// import { fetchAccount } from "features/accounts/accountThunk";
// import { resetFleetState } from "../../../features/live_map/fleetSlice";
// import { useMaterialUIController, setMiniSidenav } from "context";

// // MUI
// import IconButton from "@mui/material/IconButton";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import XIcon from "@mui/icons-material/X";
// import whatsappIcon from "../../../assets/whatsapp.png"; // your local image path

// // Assets
// import mainLogo from "../../../assets/images/logo-ct-dark.png";

// /* ─────────────────────────────────────────
//    SLIDE DATA


   
// ───────────────────────────────────────── */
// const SLIDES = [
//   {
//     tag: "Live GPS Tracking",
//     title: ["Know Where Your", "Fleet Is,", "Always."],
//     highlight: 1,
//     description:
//       "Track every vehicle on a live map with pinpoint GPS accuracy. Get instant alerts, route history, and full visibility — anytime, anywhere.",
//     stats: ["12 Vehicles Live", "Real-Time GPS"],
//     features: [
//       { icon: "📍", label: "GPS Accuracy" },
//       { icon: "🔔", label: "Instant Alerts" },
//       { icon: "🗂️", label: "Route History" },
//     ],
//   },
//   {
//     tag: "Cost Control",
//     title: ["Cut Costs.", "Maximize", "Efficiency."],
//     highlight: 2,
//     description:
//       "Smart route optimisation and fuel monitoring help reduce operational costs. Stop overspending — let data drive every decision.",
//     stats: ["18% Fuel Saved", "Smart Routing"],
//     features: [
//       { icon: "🛣️", label: "Route Optimisation" },
//       { icon: "📊", label: "Fuel Analytics" },
//       { icon: "💰", label: "Cost Reports" },
//     ],
//   },
//   {
//     tag: "Safety & Compliance",
//     title: ["Safer Drivers.", "Smarter", "Operations."],
//     highlight: 1,
//     description:
//       "Monitor driver behaviour, set geofence boundaries, and ensure compliance — all from one powerful dashboard built for fleet managers.",
//     stats: ["Driver Safety Score", "Geofence Active"],
//     features: [
//       { icon: "🧭", label: "Geofencing" },
//       { icon: "👤", label: "Driver Scores" },
//       { icon: "📋", label: "Compliance" },
//     ],
//   },
//   {
//     tag: "AI Dashcam & Video",
//     title: ["See Everything.", "Protect", "Your Fleet."],
//     highlight: 1,
//     description:
//       "AI-powered dashcams with DMS and video telematics give you eyes everywhere — detect incidents, improve driver behaviour, and reduce liability.",
//     stats: ["AI DMS Active", "Live Video Feed"],
//     features: [
//       { icon: "🎥", label: "Video Telematics" },
//       { icon: "🤖", label: "AI DMS" },
//       { icon: "🛡️", label: "Incident Detection" },
//     ],
//   },
// ];

// const INDUSTRY_PILLS = [
//   { icon: "🏫", label: "School Bus" },
//   { icon: "🏢", label: "Corporate Cabs" },
//   { icon: "🚚", label: "Logistics" },
//   { icon: "⚡", label: "EV Fleet" },
//   { icon: "⛵", label: "Boat Tracking" },
//   { icon: "🚑", label: "Ambulance" },
//   { icon: "⛽", label: "Fuel Monitor" },
//   { icon: "🎥", label: "AI Dashcam" },
//   { icon: "🌡️", label: "Temperature" },
//   { icon: "👷", label: "Field Staff" },
//   { icon: "📍", label: "GPS Tracking" },
//   { icon: "🪪", label: "RFID Attendance" },
//   { icon: "⛽", label: "Fuel Monitor" },
//   { icon: "🛣️", label: "Route Optimisation" },
//   { icon: "🎥", label: "AI Dashcam" },
//   { icon: "📹", label: "Video Telematics" },
// ];

// /* ─────────────────────────────────────────
//    STYLES
// ───────────────────────────────────────── */
// const S = {
//   wrapper: {
//     display: "flex",
//     minHeight: "100vh",
//     fontFamily: "'Inter', sans-serif",
//     backgroundColor: "#fff",
//     overflow: "hidden",
//   },

//   /* ── LEFT ── */
//   left: {
//     flex: "0 0 56%",
//     background: "#07112a",
//     position: "relative",
//     overflow: "hidden",
//     display: "flex",
//     flexDirection: "column",
//   },
//   gridOverlay: {
//     position: "absolute",
//     inset: 0,
//     backgroundImage:
//       "linear-gradient(rgba(0,201,167,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(0,201,167,0.06) 1px, transparent 1px)",
//     backgroundSize: "32px 32px",
//     animation: "gridDrift 25s linear infinite",
//     zIndex: 0,
//   },
//   orb1: {
//     position: "absolute", width: 380, height: 380, borderRadius: "50%",
//     background: "#f39507", filter: "blur(90px)", opacity: 0.15,
//     top: -100, right: -80, zIndex: 0, pointerEvents: "none",
//   },
//   orb2: {
//     position: "absolute", width: 280, height: 280, borderRadius: "50%",
//     background: "#00c9a7", filter: "blur(90px)", opacity: 0.12,
//     bottom: 0, left: -60, zIndex: 0, pointerEvents: "none",
//   },
//   orb3: {
//     position: "absolute", width: 180, height: 180, borderRadius: "50%",
//     background: "#3b82f6", filter: "blur(80px)", opacity: 0.08,
//     top: "45%", left: "30%", zIndex: 0, pointerEvents: "none",
//   },
//   mapBg: { position: "absolute", inset: 0, opacity: 0.45, zIndex: 0 },

//   signalRings: { position: "absolute", zIndex: 1, pointerEvents: "none" },
//   ring: (delay) => ({
//     position: "absolute", borderRadius: "50%",
//     border: "1.5px solid rgba(0,201,167,0.5)",
//     transform: "translate(-50%, -50%)",
//     animation: `ringPulse 3s ease-out ${delay}s infinite`,
//   }),
//   gpsPin: (delay) => ({
//     position: "absolute", display: "flex", flexDirection: "column",
//     alignItems: "center", animation: `pinBob 3s ease-in-out ${delay}s infinite`,
//     zIndex: 2, pointerEvents: "none",
//   }),
//   pinHead: (color) => ({
//     width: 22, height: 22, borderRadius: "50% 50% 50% 0",
//     background: color, transform: "rotate(-45deg)",
//     display: "flex", alignItems: "center", justifyContent: "center",
//     boxShadow: "0 3px 12px rgba(0,0,0,0.4)", position: "relative",
//   }),
//   pinDot: {
//     width: 9, height: 9, background: "rgba(255,255,255,0.9)",
//     borderRadius: "50%", transform: "rotate(45deg)",
//   },
//   vehicleDot: { position: "absolute", zIndex: 3, pointerEvents: "none" },
//   vdotInner: (bg, delay) => ({
//     width: 28, height: 28, borderRadius: 8, background: bg,
//     display: "flex", alignItems: "center", justifyContent: "center",
//     fontSize: 14, animation: `vPulse 2s ease-in-out ${delay}s infinite`,
//     boxShadow: "0 2px 10px rgba(0,0,0,0.3)", border: "1.5px solid rgba(255,255,255,0.2)",
//   }),
//   routeLine: (top, left, width, delay, rotate) => ({
//     position: "absolute", top, left, width, height: 2,
//     background: "linear-gradient(90deg, transparent, #00c9a7, transparent)",
//     borderRadius: 2, opacity: 0,
//     animation: `routeAnim 5s linear ${delay}s infinite`,
//     zIndex: 1, pointerEvents: "none", transform: `rotate(${rotate}deg)`,
//   }),

//   leftContent: {
//     position: "relative", zIndex: 5, display: "flex",
//     flexDirection: "column", height: "100%", padding: "28px 44px",
//   },
//   brandRow: { display: "flex", alignItems: "center", gap: 12, marginBottom: 32 },
//   brandLogo: {
//     width: 42, height: 42, borderRadius: 11,
//     background: "linear-gradient(135deg, #fff, #fff)",
//     display: "flex", alignItems: "center", justifyContent: "center",
//     boxShadow: "0 4px 18px #fff", overflow: "hidden", flexShrink: 0,
//   },
//   brandName: {
//     fontFamily: "'Outfit', sans-serif", fontWeight: 800,
//     fontSize: "1.55rem", color: "#fff", letterSpacing: "0.02em",
//   },

//   slidesArea: { flex: 1, position: "relative", minHeight: 0 },
//   slide: (active, exiting) => ({
//     position: "absolute", inset: 0, display: "flex",
//     flexDirection: "column", justifyContent: "center",
//     opacity: active ? 1 : 0,
//     transform: active ? "translateX(0)" : exiting ? "translateX(-24px)" : "translateX(24px)",
//     transition: "all 0.6s cubic-bezier(0.4,0,0.2,1)",
//     pointerEvents: active ? "auto" : "none",
//   }),
//   slideTag: {
//     display: "inline-flex", alignItems: "center", gap: 7,
//     background: "rgba(243,149,7,0.18)", color: "#f39507",
//     borderRadius: 20, padding: "4px 14px", fontSize: "0.7rem",
//     fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase",
//     marginBottom: 16, width: "fit-content", border: "1px solid rgba(243,149,7,0.25)",
//   },
//   tagDot: {
//     width: 6, height: 6, borderRadius: "50%", background: "#f39507",
//     animation: "dotBlink 1.5s ease-in-out infinite", flexShrink: 0,
//   },
//   slideTitle: {
//     fontFamily: "'Outfit', sans-serif", fontWeight: 800,
//     fontSize: "2.4rem", lineHeight: 1.15, color: "#fff", marginBottom: 16,
//   },
//   titleLine: (isHighlight) => ({ color: isHighlight ? "#f39507" : "#fff", display: "block" }),
//   slideDesc: {
//     fontSize: "0.92rem", color: "rgba(255,255,255,0.58)",
//     lineHeight: 1.75, maxWidth: 400, marginBottom: 16,
//   },
//   statsRow: { display: "flex", gap: 10, marginBottom: 20 },
//   statPill: {
//     background: "rgba(0,201,167,0.1)", border: "1px solid rgba(0,201,167,0.22)",
//     borderRadius: 20, padding: "6px 14px", display: "flex", alignItems: "center",
//     gap: 8, fontSize: "0.76rem", color: "#00c9a7", fontWeight: 500, letterSpacing: "0.03em",
//   },
//   statDot: {
//     width: 6, height: 6, borderRadius: "50%", background: "#00c9a7",
//     animation: "dotBlink 2s ease-in-out infinite", flexShrink: 0,
//   },
//   featuresRow: { display: "flex", gap: 10, flexWrap: "wrap" },
//   featChip: {
//     background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
//     borderRadius: 10, padding: "10px 14px", display: "flex", alignItems: "center",
//     gap: 9, fontSize: "0.8rem", color: "rgba(255,255,255,0.8)", fontWeight: 500,
//     cursor: "default", transition: "background 0.2s",
//   },
//   industryStrip: {
//     display: "flex", flexWrap: "wrap", gap: 6, marginTop: "auto",
//     paddingTop: 20, borderTop: "1px solid rgba(255,255,255,0.07)",
//   },
//   indPill: {
//     background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.08)",
//     borderRadius: 6, padding: "4px 10px", fontSize: "0.68rem",
//     color: "rgba(255,255,255,0.45)", fontWeight: 500, letterSpacing: "0.03em",
//     cursor: "default", transition: "all 0.2s",
//   },
//   dotsRow: { display: "flex", gap: 8, marginTop: 24 },
//   dotBtn: (active) => ({
//     height: 4, width: active ? 44 : 28, borderRadius: 2, border: "none",
//     cursor: "pointer", transition: "all 0.3s", padding: 0,
//     background: active ? "#f39507" : "rgba(255,255,255,0.2)",
//   }),

//   /* ── RIGHT ── */
//   right: {
//     flex: "0 0 44%",
//     background: "#ffffff",
//     display: "flex",
//     flexDirection: "column",         /* ← column so footer sits at bottom */
//     alignItems: "center",
//     justifyContent: "space-between", /* ← pushes footer to bottom */
//     padding: "48px 44px 0",          /* ← no bottom padding; footer handles it */
//     position: "relative",
//     overflowY: "auto",
//   },
//   rightGlow: {
//     position: "absolute", top: 0, right: 0, width: 220, height: 220,
//     background: "radial-gradient(circle, rgba(243,149,7,0.07) 0%, transparent 70%)",
//     pointerEvents: "none",
//   },
//   rightGlow2: {
//     position: "absolute", bottom: 0, left: 0, width: 180, height: 180,
//     background: "radial-gradient(circle, rgba(0,201,167,0.05) 0%, transparent 70%)",
//     pointerEvents: "none",
//   },
//   formInner: { width: "100%", maxWidth: 360, position: "relative", zIndex: 1 },
//   portalLabel: {
//     fontSize: "0.72rem", fontWeight: 600, letterSpacing: "0.13em",
//     textTransform: "uppercase", color: "#f39507", marginBottom: 8,
//   },
//   loginTitle: {
//     fontFamily: "'Outfit', sans-serif", fontWeight: 800,
//     fontSize: "1.9rem", color: "#0f1b35", marginBottom: 5, lineHeight: 1.2,
//   },
//   loginSubtitle: { fontSize: "0.86rem", color: "#8a94a6", marginBottom: 28, lineHeight: 1.5 },
//   formGroup: { marginBottom: 16 },
//   formLabel: {
//     display: "block", fontSize: "0.78rem", fontWeight: 600,
//     color: "#374151", marginBottom: 7, letterSpacing: "0.02em",
//   },
//   inputWrap: { position: "relative" },
//   inputIcon: {
//     position: "absolute", left: 13, top: "50%", transform: "translateY(-50%)",
//     fontSize: 14, pointerEvents: "none", zIndex: 1, color: "#9ca3af",
//   },
//   input: (focused) => ({
//     width: "100%", padding: "11px 13px 11px 38px",
//     border: `1.5px solid ${focused ? "#f39507" : "#e5e7eb"}`, borderRadius: 10,
//     fontFamily: "'Inter', sans-serif", fontSize: "0.88rem", color: "#0f1b35",
//     background: focused ? "#fff" : "#fafafa",
//     boxShadow: focused ? "0 0 0 3px rgba(243,149,7,0.1)" : "none",
//     outline: "none", transition: "all 0.2s", boxSizing: "border-box",
//   }),
//   formRow: {
//     display: "flex", alignItems: "center",
//     justifyContent: "space-between", marginBottom: 20,
//   },
//   rememberWrap: {
//     display: "flex", alignItems: "center", gap: 7,
//     cursor: "pointer", userSelect: "none",
//   },
//   checkBox: (checked) => ({
//     width: 16, height: 16,
//     border: `1.5px solid ${checked ? "#f39507" : "#d1d5db"}`,
//     borderRadius: 4, background: checked ? "#f39507" : "transparent",
//     display: "flex", alignItems: "center", justifyContent: "center",
//     flexShrink: 0, transition: "all 0.2s", cursor: "pointer",
//   }),
//   rememberLabel: { fontSize: "0.8rem", color: "#6b7280" },
//   forgotLink: {
//     fontSize: "0.8rem", color: "#f39507", fontWeight: 500,
//     cursor: "pointer", textDecoration: "none",
//   },
//   signBtn: (loading) => ({
//     width: "100%", padding: "13px",
//     background: loading
//       ? "rgba(243,149,7,0.28)"
//       : "linear-gradient(135deg, rgba(243,149,7,0.75), rgba(217,127,0,0.75))",
//     color: "#fff", fontFamily: "'Outfit', sans-serif", fontWeight: 700,
//     fontSize: "0.95rem", letterSpacing: "0.04em", border: "none", borderRadius: 10,
//     cursor: loading ? "not-allowed" : "pointer",
//     boxShadow: "0 4px 18px rgba(243,149,7,0.35)",
//     display: "flex", alignItems: "center", justifyContent: "center",
//     gap: 8, transition: "all 0.25s",
//   }),
//   divider: { display: "flex", alignItems: "center", gap: 12, margin: "20px 0" },
//   divLine: { flex: 1, height: 1, background: "#e5e7eb" },
//   divText: { fontSize: "0.72rem", color: "#9ca3af", whiteSpace: "nowrap" },
//   socialRow: { display: "flex", gap: 10, justifyContent: "center" },
//   socialBtn: {
//     width: 42, height: 42, borderRadius: 10, border: "1.5px solid #e5e7eb",
//     background: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
//     cursor: "pointer", fontSize: 18, transition: "all 0.2s", textDecoration: "none",
//   },
//   trustBar: {
//     marginTop: 20, padding: "12px 16px",
//     background: "linear-gradient(135deg, #f0fdf9, #f0f9ff)",
//     border: "1px solid rgba(0,201,167,0.2)", borderRadius: 10,
//     display: "flex", alignItems: "center", gap: 11,
//   },
//   trustText: { fontSize: "0.75rem", color: "#374151", lineHeight: 1.45 },

//   /* ── FOOTER ── */
//   footer: {
//     width: "100%",
//     borderTop: "1px solid #f0f0f0",
//     padding: "14px 0 16px",
//     marginTop: 24,
//     position: "relative",
//     zIndex: 1,
//   },
//   footerInner: {
//     maxWidth: 360,
//     margin: "0 auto",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: 10,
//   },
//   footerCopy: {
//     fontSize: "0.7rem",
//     color: "#9ca3af",
//     textAlign: "center",
//     lineHeight: 1.5,
//   },
//   footerLinks: {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     gap: "4px 16px",
//     listStyle: "none",
//     margin: 0,
//     padding: 0,
//   },
//   footerLink: {
//     fontSize: "0.72rem",
//     color: "#6b7280",
//     textDecoration: "none",
//     fontWeight: 500,
//     transition: "color 0.2s",
//     cursor: "pointer",
//   },
// };

// /* ─────────────────────────────────────────
//    FOOTER SUB-COMPONENT
// ───────────────────────────────────────── */
// function LoginFooter() {
//   const links = [
//     { label: "About Us", href: "https://www.routegrip.com/#about" },
//     // { label: "Blogs", href: "https://dhundhoo.com/posts" },
//     { label: "Contact Us", href: "https://www.routegrip.com/#contact" },
//     // { label: "Pricing", href: "https://dhundhoo.com/pricing" },
//   ];

//   return (
//     <footer style={S.footer}>
//       <div style={S.footerInner}>
//         {/* Nav links */}
//         <ul style={S.footerLinks}>
//           {links.map((l) => (
//             <li key={l.label}>
//               <a
//                 href={l.href}
//                 target="_blank"
//                 rel="noreferrer"
//                 style={S.footerLink}
//                 className="footer-link-hover"
//               >
//                 {l.label}
//               </a>
//             </li>
//           ))}
//         </ul>

//         {/* Copyright */}
//         <p style={S.footerCopy}>
//           <a
//             href="https://www.routegrip.com/"
//             target="_blank"
//             rel="noreferrer"
//             style={{ color: "#f39507", fontWeight: 600, textDecoration: "none" }}
//           >
//             © {new Date().getFullYear()} Trackula Services Pvt Ltd.
//           </a>
//           {" "}All Rights Reserved.
//         </p>
//       </div>
//     </footer>
//   );
// }

// /* ─────────────────────────────────────────
//    MAIN COMPONENT
// ───────────────────────────────────────── */
// function Basic() {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [exitingSlide, setExitingSlide] = useState(null);
//   const [rememberMe, setRememberMe] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [emailFocused, setEmailFocused] = useState(false);
//   const [passFocused, setPassFocused] = useState(false);
//   const [installToken, setInstallToken] = useState("");

//   const autoRef = useRef(null);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [controller, muiDispatch] = useMaterialUIController();
//   const { orgName } = useSelector((state) => state.apiData);

//   useEffect(() => {
//     setMiniSidenav(muiDispatch, true);

//     const link = document.createElement("link");
//     link.rel = "stylesheet";
//     link.href =
//       "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Outfit:wght@400;500;600;700;800;900&display=swap";
//     document.head.appendChild(link);

//     const tabler = document.createElement("link");
//     tabler.rel = "stylesheet";
//     tabler.href = "https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/tabler-icons.min.css";
//     document.head.appendChild(tabler);

//     const style = document.createElement("style");
//     style.textContent = `
//       @keyframes gridDrift { 0%{background-position:0 0} 100%{background-position:32px 32px} }
//       @keyframes dotBlink { 0%,100%{opacity:1} 50%{opacity:.4} }
//       @keyframes pinBob { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }
//       @keyframes vPulse { 0%,100%{transform:scale(1)} 50%{transform:scale(1.08)} }
//       @keyframes ringPulse {
//         0%  { width:8px; height:8px; opacity:1; }
//         100%{ width:80px; height:80px; opacity:0; }
//       }
//       @keyframes routeAnim {
//         0%  { opacity:0; transform:scaleX(0); transform-origin:left; }
//         15% { opacity:0.5; }
//         85% { opacity:0.5; }
//         100%{ opacity:0; transform:scaleX(1); transform-origin:left; }
//       }
// @keyframes movePath { 0%{offset-distance:100%} 100%{offset-distance:0%} }
//       @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.5} }

//       .feat-chip-hover:hover { background:rgba(255,255,255,0.1) !important; }
//       .ind-pill-hover:hover {
//         background:rgba(0,201,167,0.1) !important;
//         border-color:rgba(0,201,167,0.25) !important;
//         color:#00c9a7 !important;
//       }
//       .social-btn-hover:hover {
//         border-color:#f39507 !important;
//         background:rgba(243,149,7,0.05) !important;
//         transform:translateY(-2px);
//       }
//       .sign-btn-hover:hover:not(:disabled) {
//         transform:translateY(-1px);
//         box-shadow:0 6px 24px rgba(243,149,7,0.42) !important;
//       }
//       .footer-link-hover:hover { color:#f39507 !important; }

//       /* ── Mobile: hide left, expand right ── */
//       @media (max-width: 768px) {
//         .login-left  { display: none !important; }
//         .login-right {
//           flex: 1 1 100% !important;
//           padding: 32px 24px 0 !important;
//         }
//         .login-wrapper { flex-direction: column !important; }
//       }
//     `;
//     document.head.appendChild(style);

//     dispatch({ type: "LOGOUT" });
//     dispatch(resetFleetState());

//     let token = localStorage.getItem("installToken");
//     if (!token) { token = uuidv4(); localStorage.setItem("installToken", token); }
//     setInstallToken(token);

//     return () => {
//       document.head.removeChild(link);
//       document.head.removeChild(tabler);
//       document.head.removeChild(style);
//     };
//   }, []);

//   /* auto-advance slides */
//   useEffect(() => {
//     autoRef.current = setInterval(() => {
//       setCurrentSlide((prev) => {
//         const next = (prev + 1) % SLIDES.length;
//         setExitingSlide(prev);
//         setTimeout(() => setExitingSlide(null), 700);
//         return next;
//       });
//     }, 4000);
//     return () => clearInterval(autoRef.current);
//   }, []);

//   const goSlide = (n) => {
//     if (n === currentSlide) return;
//     clearInterval(autoRef.current);
//     setExitingSlide(currentSlide);
//     setTimeout(() => setExitingSlide(null), 700);
//     setCurrentSlide(n);
//     autoRef.current = setInterval(() => {
//       setCurrentSlide((prev) => {
//         const next = (prev + 1) % SLIDES.length;
//         setExitingSlide(prev);
//         setTimeout(() => setExitingSlide(null), 700);
//         return next;
//       });
//     }, 4000);
//   };

//   localStorage.setItem("orgName", orgName || "");

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     dispatch(resetFleetState());
//     try {
//       const signinRes = await axios.post(API.login, {
//         emailId: email,
//         encodedPassword: MD5(password).toString(),
//         demo: "false",
//         mode: "EMAIL",
//         installToken,
//       });

//       if (signinRes.data?.accessCode) {
//         const authRes = await axios.post(API.authorize, {
//           accessCode: signinRes.data.accessCode,
//           platform: "WEB",
//           version: "0.2.0",
//         });
      
//         try {
//           const roleRes = await axios.post(
//             "https://v3.dhundhoo.com/ev/getUserRoleForBoat",
//             {
//               accessCode: signinRes.data.accessCode,
//               platform: "WEB",
//               version: "0.2.0"
//             },
//             {
//               headers: {
//                 "x-dhundhoo-session": authRes.data.session
//               }
//             }
//           );

//           if (typeof roleRes.data === 'string' && roleRes.data.includes("User not found")) {
//             localStorage.setItem("userRole", "ADMIN");
//           } else if (roleRes.data && roleRes.data.roleName) {
//             localStorage.setItem("userRole", roleRes.data.roleName);
//           }
//         } catch (roleErr) {
//           if (
//             roleErr.response &&
//             typeof roleErr.response.data === 'string' &&
//             roleErr.response.data.includes("User not found")
//           ) {
//             localStorage.setItem("userRole", "ADMIN");
//           } else {
//             console.error("Failed to fetch user role, defaulting to full access:", roleErr);
//             localStorage.setItem("userRole", "ADMIN");
//           }
//         }

//         localStorage.removeItem("accessCode");
//         localStorage.removeItem("token");
//         localStorage.setItem("accessCode", signinRes.data.accessCode);
//         localStorage.setItem("token", authRes.data.session);

//         await dispatch(fetchAccount());
//         setMiniSidenav(muiDispatch, true);
//         navigate("/Live-Map");
//       } else {
//         alert("Login failed: No access code received.");
//       }
//     } catch (err) {
//       console.error("Login error:", err);
//       alert("Login failed. Please check your credentials.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const handleLogin = async (e) => {
//   //   e.preventDefault();
//   //   setLoading(true);
//   //   dispatch(resetFleetState());
//   //   try {
//   //     const signinRes = await axios.post(API.login, {
//   //       emailId: email,
//   //       encodedPassword: MD5(password).toString(),
//   //       demo: "false",
//   //       mode: "EMAIL",
//   //       installToken,
//   //     });

//   //     if (signinRes.data?.accessCode) {
//   //       const authRes = await axios.post(API.authorize, {
//   //         accessCode: signinRes.data.accessCode,
//   //         platform: "WEB",
//   //         version: "0.2.0",
//   //       });
//   //       localStorage.removeItem("accessCode");
//   //       localStorage.removeItem("token");
//   //       localStorage.setItem("accessCode", signinRes.data.accessCode);
//   //       localStorage.setItem("token", authRes.data.session);

//   //       await dispatch(fetchAccount());
//   //       // await dispatch(fetchApiData()).unwrap();
//   //       setMiniSidenav(muiDispatch, true);
//   //       navigate("/Live-Map");
//   //     } else {
//   //       alert("Login failed: No access code received.");
//   //     }
//   //   } catch (err) {
//   //     console.error("Login error:", err);
//   //     alert("Login failed. Please check your credentials.");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   return (
//     <div style={S.wrapper} className="login-wrapper">

//       {/* ══════════ LEFT PANEL ══════════ */}
//       <div style={S.left} className="login-left">
//         <div style={S.gridOverlay} />
//         <div style={S.orb1} /><div style={S.orb2} /><div style={S.orb3} />

//         {/* Animated SVG road map */}
//         <svg style={S.mapBg} viewBox="0 0 600 700" preserveAspectRatio="xMidYMid slice">
//           <defs>
//             <path id="r1" d="M -60 200 Q 150 180 300 220 Q 420 250 660 230" />
//             <path id="r2" d="M -60 400 Q 120 380 250 420 Q 400 450 660 410" />
//             <path id="r3" d="M 150 -30 Q 180 150 200 300 Q 220 450 180 730" />
//             <path id="r4" d="M 350 -30 Q 370 200 400 350 Q 420 500 380 730" />
//             <path id="r5" d="M -60 120 Q 200 140 400 100 Q 500 85 660 110" />
//             <path id="r6" d="M 660 400 Q 550 600 450 590 Q 250 570 50 600" />
//           </defs>
//           <g stroke="rgba(0,201,167,0.18)" strokeWidth="1.5" fill="none">
//             <use href="#r1" /><use href="#r2" /><use href="#r3" />
//             <use href="#r4" /><use href="#r5" /><use href="#r6" />
//           </g>
//           <g stroke="rgba(0,201,167,0.08)" strokeWidth="0.8" fill="none">
//             <path d="M 0 300 Q 100 310 200 290 Q 350 270 600 320" />
//             <path d="M 250 0 Q 260 300 240 700" />
//             <path d="M 0 500 Q 300 480 600 520" />
//           </g>
//           <g fill="rgba(0,201,167,0.3)">
//             <circle cx="180" cy="200" r="4" /><circle cx="380" cy="290" r="4" />
//             <circle cx="100" cy="430" r="4" /><circle cx="470" cy="150" r="4" />
//             <circle cx="260" cy="560" r="4" /><circle cx="520" cy="490" r="4" />
//           </g>
//           <g fill="rgba(255,255,255,0.03)" stroke="rgba(0,201,167,0.07)" strokeWidth="0.5">
//             <rect x="60" y="60" width="40" height="30" rx="2" />
//             <rect x="200" y="80" width="30" height="45" rx="2" />
//             <rect x="320" y="50" width="55" height="25" rx="2" />
//             <rect x="480" y="300" width="35" height="50" rx="2" />
//             <rect x="80" y="480" width="50" height="35" rx="2" />
//             <rect x="400" y="500" width="45" height="40" rx="2" />
//           </g>
//           {[
//             { path: "M -60 200 Q 150 180 300 220 Q 420 250 660 230", dur: "12s", delay: "0s", bg: "rgba(243,149,7,0.85)", icon: "🚌" },

//             { path: "M -60 400 Q 120 380 250 420 Q 400 450 660 410", dur: "16s", delay: "3s", bg: "rgba(0,201,167,0.8)", icon: "🚚" },
//             { path: "M -60 120 Q 200 140 400 100 Q 500 85 660 110", dur: "10s", delay: "1s", bg: "rgba(59,130,246,0.85)", icon: "🚑" },
//             { path: "M -60 200 Q 150 180 300 220 Q 420 250 660 230", dur: "14s", delay: "6s", bg: "rgba(168,85,247,0.8)", icon: "🚕" },
//             { path: "M 660 400 Q 550 600 450 590 Q 250 570 50 600", dur: "18s", delay: "2s", bg: "rgba(14,165,233,0.8)", icon: "⛵" },
//             { path: "M 150 -30 Q 180 150 200 300 Q 220 450 180 730", dur: "15s", delay: "4s", bg: "rgba(16,185,129,0.85)", icon: "⚡" },
//             { path: "M 350 -30 Q 370 200 400 350 Q 420 500 380 730", dur: "20s", delay: "8s", bg: "rgba(251,146,60,0.85)", icon: "🚛" },
//           ].map((v, i) => (
//             <g key={i} style={{ offsetPath: `path('${v.path}')`, animation: `movePath ${v.dur} linear ${v.delay} infinite` }}>
//               <rect x="-14" y="-10" width="28" height="18" rx="4" fill={v.bg} stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
//               <text x="0" y="4" textAnchor="middle" fontSize="11" dominantBaseline="middle">{v.icon}</text>
//             </g>
//           ))}
//         </svg>

//         {/* Signal rings */}
//         <div style={{ ...S.signalRings, top: "28%", left: "35%" }}>
//           {[0, 1, 2].map((i) => <div key={i} style={S.ring(i)} />)}
//         </div>
//         <div style={{ ...S.signalRings, top: "60%", left: "65%" }}>
//           {[0.5, 1.5, 2.5].map((d, i) => <div key={i} style={S.ring(d)} />)}
//         </div>

//         {/* GPS Pins */}
//         <div style={{ ...S.gpsPin(0), top: "26%", left: "33%" }}>
//           <div style={S.pinHead("linear-gradient(135deg,#f39507,#ffb84d)")}><div style={S.pinDot} /></div>
//         </div>
//         <div style={{ ...S.gpsPin(1.2), top: "58%", left: "63%" }}>
//           <div style={S.pinHead("linear-gradient(135deg,#00c9a7,#00e8c0)")}><div style={S.pinDot} /></div>
//         </div>
//         <div style={{ ...S.gpsPin(0.6), top: "42%", left: "95%" }}>
//           <div style={S.pinHead("linear-gradient(135deg,#3b82f6,#60a5fa)")}><div style={S.pinDot} /></div>
//         </div>

//         {/* Vehicle dots */}
//         {[
//           { top: "19%", left: "52%", bg: "rgba(243,149,7,0.2)", delay: 0.3, icon: "🚌" },
//           { top: "72%", left: "22%", bg: "rgba(0,201,167,0.2)", delay: 0.8, icon: "🚚" },
//           { top: "48%", left: "78%", bg: "rgba(59,130,246,0.2)", delay: 1.5, icon: "🚑" },
//           { top: "82%", left: "55%", bg: "rgba(168,85,247,0.2)", delay: 1.8, icon: "⛵" },
//         ].map((v, i) => (
//           <div key={i} style={{ ...S.vehicleDot, top: v.top, left: v.left }}>
//             <div style={S.vdotInner(v.bg, v.delay)}>{v.icon}</div>
//           </div>
//         ))}

//         {/* Route lines */}
//         <div style={S.routeLine("30%", "15%", "40%", 0, -5)} />
//         <div style={S.routeLine("60%", "20%", "35%", 2, 8)} />
//         <div style={S.routeLine("48%", "30%", "30%", 3.5, -3)} />

//         {/* Left content */}
//         <div style={S.leftContent}>
//           <div style={S.brandRow}>
//             <div style={S.brandLogo}>
//               <img src={mainLogo} alt="Routegrip" style={{ width: 42, height: 42, objectFit: "cover" }} />
//             </div>
//             <span style={S.brandName}>NAVYTIC</span>
//           </div>

//           <div style={S.slidesArea}>
//             {SLIDES.map((slide, i) => (
//               <div key={i} style={S.slide(i === currentSlide, i === exitingSlide)}>
//                 <div style={S.slideTag}><div style={S.tagDot} />{slide.tag}</div>
//                 <div style={S.slideTitle}>
//                   {slide.title.map((line, j) => (
//                     <span key={j} style={S.titleLine(j === slide.highlight)}>{line}</span>
//                   ))}
//                 </div>
//                 <div style={S.statsRow}>
//                   {slide.stats.map((s, j) => (
//                     <div key={j} style={S.statPill}><div style={S.statDot} />{s}</div>
//                   ))}
//                 </div>
//                 <p style={S.slideDesc}>{slide.description}</p>
//                 <div style={S.featuresRow}>
//                   {slide.features.map((f, j) => (
//                     <div key={j} style={S.featChip} className="feat-chip-hover">
//                       <span style={{ fontSize: 18 }}>{f.icon}</span>{f.label}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div style={S.dotsRow}>
//             {SLIDES.map((_, i) => (
//               <button key={i} style={S.dotBtn(i === currentSlide)} onClick={() => goSlide(i)} />
//             ))}
//           </div>

//           <div style={S.industryStrip}>
//             {INDUSTRY_PILLS.map((p, i) => (
//               <span key={i} style={S.indPill} className="ind-pill-hover">{p.icon} {p.label}</span>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* ══════════ RIGHT PANEL ══════════ */}
//       {/* ══════════ RIGHT PANEL ══════════ */}
//       <div style={S.right} className="login-right">
//         <div style={S.rightGlow} />
//         <div style={S.rightGlow2} />

//         {/* ── Form area ── */}
//         <div style={S.formInner}>
//           <div style={S.portalLabel}>Fleet Management Portal</div>
//           <div style={S.loginTitle}>Welcome back</div>
//           <div style={S.loginSubtitle}>Sign in to manage your fleet operations</div>

//           <form onSubmit={handleLogin}>
//             <div style={S.formGroup}>
//               <label style={S.formLabel}>Email address</label>
//               <div style={S.inputWrap}>
//                 <span style={S.inputIcon}>✉️</span>
//                 <input
//                   type="email" placeholder="you@company.com" value={email} required
//                   onChange={(e) => setEmail(e.target.value)}
//                   onFocus={() => setEmailFocused(true)} onBlur={() => setEmailFocused(false)}
//                   style={S.input(emailFocused)}
//                 />
//               </div>
//             </div>

//             <div style={S.formGroup}>
//               <label style={S.formLabel}>Password</label>
//               <div style={S.inputWrap}>
//                 <span style={S.inputIcon}>🔒</span>
//                 <input
//                   type={showPassword ? "text" : "password"} placeholder="Enter your password"
//                   value={password} required onChange={(e) => setPassword(e.target.value)}
//                   onFocus={() => setPassFocused(true)} onBlur={() => setPassFocused(false)}
//                   style={{ ...S.input(passFocused), paddingRight: 44 }}
//                 />
//                 <IconButton
//                   onClick={() => setShowPassword((v) => !v)} edge="end" size="small"
//                   style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}
//                 >
//                   {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
//                 </IconButton>
//               </div>
//             </div>

//             <div style={S.formRow}>
//               <div style={S.rememberWrap} onClick={() => setRememberMe((v) => !v)}>
//                 <div style={S.checkBox(rememberMe)}>
//                   {rememberMe && <span style={{ color: "#fff", fontSize: 10, fontWeight: 700, lineHeight: 1 }}>✓</span>}
//                 </div>
//                 <span style={S.rememberLabel}>Remember me</span>
//               </div>
//               <a href="#" style={S.forgotLink}>Forgot password?</a>
//             </div>

//             <button type="submit" disabled={loading} style={S.signBtn(loading)} className="sign-btn-hover">
//               {loading ? (
//                 <><span style={{ display: "inline-block", animation: "pulse 1s infinite" }}>⏳</span>Signing in...</>
//               ) : "Sign in →"}
//             </button>
//           </form>

//           <div style={S.divider}>
//             <div style={S.divLine} />
//             <span style={S.divText}>Follow Dhundhoo</span>
//             <div style={S.divLine} />
//           </div>

//           <div style={S.socialRow}>
//             {[
//               { href: "https://m.facebook.com/routegrip", icon: <FacebookIcon style={{ fontSize: 20, color: "#1877f2" }} />, title: "Facebook" },
//               // { href: "https://www.instagram.com/routegrip", icon: <InstagramIcon style={{ fontSize: 20, color: "#E4405F" }} />, title: "Instagram" },
//               { href: "https://x.com/routegrip", icon: <XIcon style={{ fontSize: 18, color: "#000" }} />, title: "X" },
//             ].map((s) => (
//               <a key={s.title} href={s.href} target="_blank" rel="noreferrer"
//                 style={S.socialBtn} className="social-btn-hover" title={s.title}>
//                 {s.icon}
//               </a>
//             ))}
//           </div>

//           <div style={S.trustBar}>
//             <span style={{ fontSize: 20, flexShrink: 0 }}>🔐</span>
//             <div style={S.trustText}>
//               <strong style={{ color: "#0f1b35", fontWeight: 600 }}>Enterprise-grade security</strong>
//               <br />
//               Your fleet data is encrypted end-to-end and compliant with global standards.
//             </div>
//           </div>
//         </div>

//         {/* ── Footer (pinned to bottom of right panel) ── */}
//         <LoginFooter />

//         {/* ── WhatsApp Floating Button ── */}

//         <a
//           href="https://wa.me/917330776253?text=Hello,%20I%20am%20interested%20in%20Routegrip%20Solutions!"
//           target="_blank"
//           rel="noreferrer"
//           title="Chat with us on WhatsApp"
//           style={{
//             position: "fixed",
//             bottom: 28,
//             right: 28,
//             width: 50,
//             height: 50,
//             borderRadius: "50%",

//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             boxShadow: "0 4px 20px rgba(37,211,102,0.45)",
//             zIndex: 9999,
//             textDecoration: "none",
//             animation: "vPulse 2s ease-in-out infinite",
//             overflow: "hidden",
//           }}
//         >
//           <img
//             src={whatsappIcon}
//             alt="WhatsApp"
//             style={{
//               width: 50,
//               height: 50,
//               objectFit: "contain",
//             }}
//           />
//         </a>
//       </div>

//     </div>
//   );
// }

// export default Basic;

import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API } from "../../../examples/config";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData } from "../../../features/account/accountthunk";
import MD5 from "crypto-js/md5";
import { v4 as uuidv4 } from "uuid";
import { fetchAccount } from "features/accounts/accountThunk";
import { resetFleetState } from "../../../features/live_map/fleetSlice";
import { useMaterialUIController, setMiniSidenav } from "context";

// MUI
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import whatsappIcon from "../../../assets/whatsapp.png"; // your local image path

// Assets
import mainLogo from "../../../assets/images/logo-ct-dark.png";

/* ─────────────────────────────────────────
   SLIDE DATA


   
───────────────────────────────────────── */
const SLIDES = [
  {
    tag: "Live GPS Tracking",
    title: ["Know Where Your", "Fleet Is,", "Always."],
    highlight: 1,
    description:
      "Track every vehicle on a live map with pinpoint GPS accuracy. Get instant alerts, route history, and full visibility — anytime, anywhere.",
    stats: ["12 Vehicles Live", "Real-Time GPS"],
    features: [
      { icon: "📍", label: "GPS Accuracy" },
      { icon: "🔔", label: "Instant Alerts" },
      { icon: "🗂️", label: "Route History" },
    ],
  },
  {
    tag: "Cost Control",
    title: ["Cut Costs.", "Maximize", "Efficiency."],
    highlight: 2,
    description:
      "Smart route optimisation and fuel monitoring help reduce operational costs. Stop overspending — let data drive every decision.",
    stats: ["18% Fuel Saved", "Smart Routing"],
    features: [
      { icon: "🛣️", label: "Route Optimisation" },
      { icon: "📊", label: "Fuel Analytics" },
      { icon: "💰", label: "Cost Reports" },
    ],
  },
  {
    tag: "Safety & Compliance",
    title: ["Safer Drivers.", "Smarter", "Operations."],
    highlight: 1,
    description:
      "Monitor driver behaviour, set geofence boundaries, and ensure compliance — all from one powerful dashboard built for fleet managers.",
    stats: ["Driver Safety Score", "Geofence Active"],
    features: [
      { icon: "🧭", label: "Geofencing" },
      { icon: "👤", label: "Driver Scores" },
      { icon: "📋", label: "Compliance" },
    ],
  },
  {
    tag: "AI Dashcam & Video",
    title: ["See Everything.", "Protect", "Your Fleet."],
    highlight: 1,
    description:
      "AI-powered dashcams with DMS and video telematics give you eyes everywhere — detect incidents, improve driver behaviour, and reduce liability.",
    stats: ["AI DMS Active", "Live Video Feed"],
    features: [
      { icon: "🎥", label: "Video Telematics" },
      { icon: "🤖", label: "AI DMS" },
      { icon: "🛡️", label: "Incident Detection" },
    ],
  },
];

const INDUSTRY_PILLS = [
  { icon: "🏫", label: "School Bus" },
  { icon: "🏢", label: "Corporate Cabs" },
  { icon: "🚚", label: "Logistics" },
  { icon: "⚡", label: "EV Fleet" },
  { icon: "⛵", label: "Boat Tracking" },
  { icon: "🚑", label: "Ambulance" },
  { icon: "⛽", label: "Fuel Monitor" },
  { icon: "🎥", label: "AI Dashcam" },
  { icon: "🌡️", label: "Temperature" },
  { icon: "👷", label: "Field Staff" },
  { icon: "📍", label: "GPS Tracking" },
  { icon: "🪪", label: "RFID Attendance" },
  { icon: "⛽", label: "Fuel Monitor" },
  { icon: "🛣️", label: "Route Optimisation" },
  { icon: "🎥", label: "AI Dashcam" },
  { icon: "📹", label: "Video Telematics" },
];

/* ─────────────────────────────────────────
   STYLES
───────────────────────────────────────── */
const S = {
  wrapper: {
    display: "flex",
    minHeight: "100vh",
    fontFamily: "'Inter', sans-serif",
    backgroundColor: "#fff",
    overflow: "hidden",
  },

  /* ── LEFT ── */
  left: {
    flex: "0 0 56%",
    background: "#07112a",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  gridOverlay: {
    position: "absolute",
    inset: 0,
    backgroundImage:
      "linear-gradient(rgba(0,201,167,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(0,201,167,0.06) 1px, transparent 1px)",
    backgroundSize: "32px 32px",
    animation: "gridDrift 25s linear infinite",
    zIndex: 0,
  },
  orb1: {
    position: "absolute", width: 380, height: 380, borderRadius: "50%",
    background: "#1398DC", filter: "blur(90px)", opacity: 0.15,
    top: -100, right: -80, zIndex: 0, pointerEvents: "none",
  },
  orb2: {
    position: "absolute", width: 280, height: 280, borderRadius: "50%",
    background: "#00c9a7", filter: "blur(90px)", opacity: 0.12,
    bottom: 0, left: -60, zIndex: 0, pointerEvents: "none",
  },
  orb3: {
    position: "absolute", width: 180, height: 180, borderRadius: "50%",
    background: "#3b82f6", filter: "blur(80px)", opacity: 0.08,
    top: "45%", left: "30%", zIndex: 0, pointerEvents: "none",
  },
  mapBg: { position: "absolute", inset: 0, opacity: 0.45, zIndex: 0 },

  signalRings: { position: "absolute", zIndex: 1, pointerEvents: "none" },
  ring: (delay) => ({
    position: "absolute", borderRadius: "50%",
    border: "1.5px solid rgba(0,201,167,0.5)",
    transform: "translate(-50%, -50%)",
    animation: `ringPulse 3s ease-out ${delay}s infinite`,
  }),
  gpsPin: (delay) => ({
    position: "absolute", display: "flex", flexDirection: "column",
    alignItems: "center", animation: `pinBob 3s ease-in-out ${delay}s infinite`,
    zIndex: 2, pointerEvents: "none",
  }),
  pinHead: (color) => ({
    width: 22, height: 22, borderRadius: "50% 50% 50% 0",
    background: color, transform: "rotate(-45deg)",
    display: "flex", alignItems: "center", justifyContent: "center",
    boxShadow: "0 3px 12px rgba(0,0,0,0.4)", position: "relative",
  }),
  pinDot: {
    width: 9, height: 9, background: "rgba(255,255,255,0.9)",
    borderRadius: "50%", transform: "rotate(45deg)",
  },
  vehicleDot: { position: "absolute", zIndex: 3, pointerEvents: "none" },
  vdotInner: (bg, delay) => ({
    width: 28, height: 28, borderRadius: 8, background: bg,
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 14, animation: `vPulse 2s ease-in-out ${delay}s infinite`,
    boxShadow: "0 2px 10px rgba(0,0,0,0.3)", border: "1.5px solid rgba(255,255,255,0.2)",
  }),
  routeLine: (top, left, width, delay, rotate) => ({
    position: "absolute", top, left, width, height: 2,
    background: "linear-gradient(90deg, transparent, #00c9a7, transparent)",
    borderRadius: 2, opacity: 0,
    animation: `routeAnim 5s linear ${delay}s infinite`,
    zIndex: 1, pointerEvents: "none", transform: `rotate(${rotate}deg)`,
  }),

  leftContent: {
    position: "relative", zIndex: 5, display: "flex",
    flexDirection: "column", height: "100%", padding: "28px 44px",
  },
  brandRow: { display: "flex", alignItems: "center", gap: 12, marginBottom: 32 },
  brandLogo: {
    width: 42, height: 42, borderRadius: 11,
    background: "linear-gradient(135deg, #fff, #fff)",
    display: "flex", alignItems: "center", justifyContent: "center",
    boxShadow: "0 4px 18px #fff", overflow: "hidden", flexShrink: 0,
  },
  brandName: {
    fontFamily: "'Outfit', sans-serif", fontWeight: 800,
    fontSize: "1.55rem", color: "#fff", letterSpacing: "0.02em",
  },

  slidesArea: { flex: 1, position: "relative", minHeight: 0 },
  slide: (active, exiting) => ({
    position: "absolute", inset: 0, display: "flex",
    flexDirection: "column", justifyContent: "center",
    opacity: active ? 1 : 0,
    transform: active ? "translateX(0)" : exiting ? "translateX(-24px)" : "translateX(24px)",
    transition: "all 0.6s cubic-bezier(0.4,0,0.2,1)",
    pointerEvents: active ? "auto" : "none",
  }),
  slideTag: {
    display: "inline-flex", alignItems: "center", gap: 7,
    background: "rgba(19,152,220,0.18)", color: "#1398DC",
    borderRadius: 20, padding: "4px 14px", fontSize: "0.7rem",
    fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase",
    marginBottom: 16, width: "fit-content", border: "1px solid rgba(19,152,220,0.25)",
  },
  tagDot: {
    width: 6, height: 6, borderRadius: "50%", background: "#1398DC",
    animation: "dotBlink 1.5s ease-in-out infinite", flexShrink: 0,
  },
  slideTitle: {
    fontFamily: "'Outfit', sans-serif", fontWeight: 800,
    fontSize: "2.4rem", lineHeight: 1.15, color: "#fff", marginBottom: 16,
  },
  titleLine: (isHighlight) => ({ color: isHighlight ? "#1398DC" : "#fff", display: "block" }),
  slideDesc: {
    fontSize: "0.92rem", color: "rgba(255,255,255,0.58)",
    lineHeight: 1.75, maxWidth: 400, marginBottom: 16,
  },
  statsRow: { display: "flex", gap: 10, marginBottom: 20 },
  statPill: {
    background: "rgba(0,201,167,0.1)", border: "1px solid rgba(0,201,167,0.22)",
    borderRadius: 20, padding: "6px 14px", display: "flex", alignItems: "center",
    gap: 8, fontSize: "0.76rem", color: "#00c9a7", fontWeight: 500, letterSpacing: "0.03em",
  },
  statDot: {
    width: 6, height: 6, borderRadius: "50%", background: "#00c9a7",
    animation: "dotBlink 2s ease-in-out infinite", flexShrink: 0,
  },
  featuresRow: { display: "flex", gap: 10, flexWrap: "wrap" },
  featChip: {
    background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 10, padding: "10px 14px", display: "flex", alignItems: "center",
    gap: 9, fontSize: "0.8rem", color: "rgba(255,255,255,0.8)", fontWeight: 500,
    cursor: "default", transition: "background 0.2s",
  },
  industryStrip: {
    display: "flex", flexWrap: "wrap", gap: 6, marginTop: "auto",
    paddingTop: 20, borderTop: "1px solid rgba(255,255,255,0.07)",
  },
  indPill: {
    background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 6, padding: "4px 10px", fontSize: "0.68rem",
    color: "rgba(255,255,255,0.45)", fontWeight: 500, letterSpacing: "0.03em",
    cursor: "default", transition: "all 0.2s",
  },
  dotsRow: { display: "flex", gap: 8, marginTop: 24 },
  dotBtn: (active) => ({
    height: 4, width: active ? 44 : 28, borderRadius: 2, border: "none",
    cursor: "pointer", transition: "all 0.3s", padding: 0,
    background: active ? "#1398DC" : "rgba(255,255,255,0.2)",
  }),

  /* ── RIGHT ── */
  right: {
    flex: "0 0 44%",
    background: "#ffffff",
    display: "flex",
    flexDirection: "column",         /* ← column so footer sits at bottom */
    alignItems: "center",
    justifyContent: "space-between", /* ← pushes footer to bottom */
    padding: "48px 44px 0",          /* ← no bottom padding; footer handles it */
    position: "relative",
    overflowY: "auto",
  },
  rightGlow: {
    position: "absolute", top: 0, right: 0, width: 220, height: 220,
    background: "radial-gradient(circle, rgba(19,152,220,0.07) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  rightGlow2: {
    position: "absolute", bottom: 0, left: 0, width: 180, height: 180,
    background: "radial-gradient(circle, rgba(0,201,167,0.05) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  formInner: { width: "100%", maxWidth: 360, position: "relative", zIndex: 1 },
  portalLabel: {
    fontSize: "0.72rem", fontWeight: 600, letterSpacing: "0.13em",
    textTransform: "uppercase", color: "#1398DC", marginBottom: 8,
  },
  loginTitle: {
    fontFamily: "'Outfit', sans-serif", fontWeight: 800,
    fontSize: "1.9rem", color: "#0f1b35", marginBottom: 5, lineHeight: 1.2,
  },
  loginSubtitle: { fontSize: "0.86rem", color: "#8a94a6", marginBottom: 28, lineHeight: 1.5 },
  formGroup: { marginBottom: 16 },
  formLabel: {
    display: "block", fontSize: "0.78rem", fontWeight: 600,
    color: "#374151", marginBottom: 7, letterSpacing: "0.02em",
  },
  inputWrap: { position: "relative" },
  inputIcon: {
    position: "absolute", left: 13, top: "50%", transform: "translateY(-50%)",
    fontSize: 14, pointerEvents: "none", zIndex: 1, color: "#9ca3af",
  },
  input: (focused) => ({
    width: "100%", padding: "11px 13px 11px 38px",
    border: `1.5px solid ${focused ? "#1398DC" : "#e5e7eb"}`, borderRadius: 10,
    fontFamily: "'Inter', sans-serif", fontSize: "0.88rem", color: "#0f1b35",
    background: focused ? "#fff" : "#fafafa",
    boxShadow: focused ? "0 0 0 3px rgba(19,152,220,0.1)" : "none",
    outline: "none", transition: "all 0.2s", boxSizing: "border-box",
  }),
  formRow: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between", marginBottom: 20,
  },
  rememberWrap: {
    display: "flex", alignItems: "center", gap: 7,
    cursor: "pointer", userSelect: "none",
  },
  checkBox: (checked) => ({
    width: 16, height: 16,
    border: `1.5px solid ${checked ? "#1398DC" : "#d1d5db"}`,
    borderRadius: 4, background: checked ? "#1398DC" : "transparent",
    display: "flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0, transition: "all 0.2s", cursor: "pointer",
  }),
  rememberLabel: { fontSize: "0.8rem", color: "#6b7280" },
  forgotLink: {
    fontSize: "0.8rem", color: "#1398DC", fontWeight: 500,
    cursor: "pointer", textDecoration: "none",
  },
  signBtn: (loading) => ({
    width: "100%", padding: "13px",
    background: loading
      ? "rgba(19,152,220,0.28)"
      : "linear-gradient(135deg, rgba(19,152,220,0.75), rgba(15,120,176,0.75))",
    color: "#fff", fontFamily: "'Outfit', sans-serif", fontWeight: 700,
    fontSize: "0.95rem", letterSpacing: "0.04em", border: "none", borderRadius: 10,
    cursor: loading ? "not-allowed" : "pointer",
    boxShadow: "0 4px 18px rgba(19,152,220,0.35)",
    display: "flex", alignItems: "center", justifyContent: "center",
    gap: 8, transition: "all 0.25s",
  }),
  divider: { display: "flex", alignItems: "center", gap: 12, margin: "20px 0" },
  divLine: { flex: 1, height: 1, background: "#e5e7eb" },
  divText: { fontSize: "0.72rem", color: "#9ca3af", whiteSpace: "nowrap" },
  socialRow: { display: "flex", gap: 10, justifyContent: "center" },
  socialBtn: {
    width: 42, height: 42, borderRadius: 10, border: "1.5px solid #e5e7eb",
    background: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer", fontSize: 18, transition: "all 0.2s", textDecoration: "none",
  },
  trustBar: {
    marginTop: 20, padding: "12px 16px",
    background: "linear-gradient(135deg, #f0fdf9, #f0f9ff)",
    border: "1px solid rgba(0,201,167,0.2)", borderRadius: 10,
    display: "flex", alignItems: "center", gap: 11,
  },
  trustText: { fontSize: "0.75rem", color: "#374151", lineHeight: 1.45 },

  /* ── FOOTER ── */
  footer: {
    width: "100%",
    borderTop: "1px solid #f0f0f0",
    padding: "14px 0 16px",
    marginTop: 24,
    position: "relative",
    zIndex: 1,
  },
  footerInner: {
    maxWidth: 360,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
  },
  footerCopy: {
    fontSize: "0.7rem",
    color: "#9ca3af",
    textAlign: "center",
    lineHeight: 1.5,
  },
  footerLinks: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "4px 16px",
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  footerLink: {
    fontSize: "0.72rem",
    color: "#6b7280",
    textDecoration: "none",
    fontWeight: 500,
    transition: "color 0.2s",
    cursor: "pointer",
  },
};

/* ─────────────────────────────────────────
   FOOTER SUB-COMPONENT
───────────────────────────────────────── */
function LoginFooter() {
  const links = [
    { label: "About Us", href: "https://www.routegrip.com/#about" },
    // { label: "Blogs", href: "https://dhundhoo.com/posts" },
    { label: "Contact Us", href: "https://www.routegrip.com/#contact" },
    // { label: "Pricing", href: "https://dhundhoo.com/pricing" },
  ];

  return (
    <footer style={S.footer}>
      <div style={S.footerInner}>
        {/* Nav links */}
        <ul style={S.footerLinks}>
          {links.map((l) => (
            <li key={l.label}>
              <a
                href={l.href}
                target="_blank"
                rel="noreferrer"
                style={S.footerLink}
                className="footer-link-hover"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Copyright */}
        <p style={S.footerCopy}>
          <a
            href="https://www.routegrip.com/"
            target="_blank"
            rel="noreferrer"
            style={{ color: "#1398DC", fontWeight: 600, textDecoration: "none" }}
          >
            © {new Date().getFullYear()} Trackula Services Pvt Ltd.
          </a>
          {" "}All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

/* ─────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────── */
function Basic() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [exitingSlide, setExitingSlide] = useState(null);
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [emailFocused, setEmailFocused] = useState(false);
  const [passFocused, setPassFocused] = useState(false);
  const [installToken, setInstallToken] = useState("");

  const autoRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [controller, muiDispatch] = useMaterialUIController();
  const { orgName } = useSelector((state) => state.apiData);

  useEffect(() => {
    setMiniSidenav(muiDispatch, true);

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Outfit:wght@400;500;600;700;800;900&display=swap";
    document.head.appendChild(link);

    const tabler = document.createElement("link");
    tabler.rel = "stylesheet";
    tabler.href = "https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/tabler-icons.min.css";
    document.head.appendChild(tabler);

    const style = document.createElement("style");
    style.textContent = `
      @keyframes gridDrift { 0%{background-position:0 0} 100%{background-position:32px 32px} }
      @keyframes dotBlink { 0%,100%{opacity:1} 50%{opacity:.4} }
      @keyframes pinBob { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }
      @keyframes vPulse { 0%,100%{transform:scale(1)} 50%{transform:scale(1.08)} }
      @keyframes ringPulse {
        0%  { width:8px; height:8px; opacity:1; }
        100%{ width:80px; height:80px; opacity:0; }
      }
      @keyframes routeAnim {
        0%  { opacity:0; transform:scaleX(0); transform-origin:left; }
        15% { opacity:0.5; }
        85% { opacity:0.5; }
        100%{ opacity:0; transform:scaleX(1); transform-origin:left; }
      }
@keyframes movePath { 0%{offset-distance:100%} 100%{offset-distance:0%} }
      @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.5} }

      .feat-chip-hover:hover { background:rgba(255,255,255,0.1) !important; }
      .ind-pill-hover:hover {
        background:rgba(0,201,167,0.1) !important;
        border-color:rgba(0,201,167,0.25) !important;
        color:#00c9a7 !important;
      }
      .social-btn-hover:hover {
        border-color:#1398DC !important;
        background:rgba(19,152,220,0.05) !important;
        transform:translateY(-2px);
      }
      .sign-btn-hover:hover:not(:disabled) {
        transform:translateY(-1px);
        box-shadow:0 6px 24px rgba(19,152,220,0.42) !important;
      }
      .footer-link-hover:hover { color:#1398DC !important; }

      /* ── Mobile: hide left, expand right ── */
      @media (max-width: 768px) {
        .login-left  { display: none !important; }
        .login-right {
          flex: 1 1 100% !important;
          padding: 32px 24px 0 !important;
        }
        .login-wrapper { flex-direction: column !important; }
      }
    `;
    document.head.appendChild(style);

    dispatch({ type: "LOGOUT" });
    dispatch(resetFleetState());

    let token = localStorage.getItem("installToken");
    if (!token) { token = uuidv4(); localStorage.setItem("installToken", token); }
    setInstallToken(token);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(tabler);
      document.head.removeChild(style);
    };
  }, []);

  /* auto-advance slides */
  useEffect(() => {
    autoRef.current = setInterval(() => {
      setCurrentSlide((prev) => {
        const next = (prev + 1) % SLIDES.length;
        setExitingSlide(prev);
        setTimeout(() => setExitingSlide(null), 700);
        return next;
      });
    }, 4000);
    return () => clearInterval(autoRef.current);
  }, []);

  const goSlide = (n) => {
    if (n === currentSlide) return;
    clearInterval(autoRef.current);
    setExitingSlide(currentSlide);
    setTimeout(() => setExitingSlide(null), 700);
    setCurrentSlide(n);
    autoRef.current = setInterval(() => {
      setCurrentSlide((prev) => {
        const next = (prev + 1) % SLIDES.length;
        setExitingSlide(prev);
        setTimeout(() => setExitingSlide(null), 700);
        return next;
      });
    }, 4000);
  };

  localStorage.setItem("orgName", orgName || "");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(resetFleetState());
    try {
      const signinRes = await axios.post(API.login, {
        emailId: email,
        encodedPassword: MD5(password).toString(),
        demo: "false",
        mode: "EMAIL",
        installToken,
      });

      if (signinRes.data?.accessCode) {
        const authRes = await axios.post(API.authorize, {
          accessCode: signinRes.data.accessCode,
          platform: "WEB",
          version: "0.2.0",
        });
      
        try {
          const roleRes = await axios.post(
            "https://v3.dhundhoo.com/ev/getUserRoleForBoat",
            {
              accessCode: signinRes.data.accessCode,
              platform: "WEB",
              version: "0.2.0"
            },
            {
              headers: {
                "x-dhundhoo-session": authRes.data.session
              }
            }
          );

          if (typeof roleRes.data === 'string' && roleRes.data.includes("User not found")) {
            localStorage.setItem("userRole", "ADMIN");
          } else if (roleRes.data && roleRes.data.roleName) {
            localStorage.setItem("userRole", roleRes.data.roleName);
          }
        } catch (roleErr) {
          if (
            roleErr.response &&
            typeof roleErr.response.data === 'string' &&
            roleErr.response.data.includes("User not found")
          ) {
            localStorage.setItem("userRole", "ADMIN");
          } else {
            console.error("Failed to fetch user role, defaulting to full access:", roleErr);
            localStorage.setItem("userRole", "ADMIN");
          }
        }

        localStorage.removeItem("accessCode");
        localStorage.removeItem("token");
        localStorage.setItem("accessCode", signinRes.data.accessCode);
        localStorage.setItem("token", authRes.data.session);

        await dispatch(fetchAccount());
        setMiniSidenav(muiDispatch, true);
        navigate("/Live-Map");
      } else {
        alert("Login failed: No access code received.");
      }
    } catch (err) {
      console.error("Login error:", err);
      alert("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   dispatch(resetFleetState());
  //   try {
  //     const signinRes = await axios.post(API.login, {
  //       emailId: email,
  //       encodedPassword: MD5(password).toString(),
  //       demo: "false",
  //       mode: "EMAIL",
  //       installToken,
  //     });

  //     if (signinRes.data?.accessCode) {
  //       const authRes = await axios.post(API.authorize, {
  //         accessCode: signinRes.data.accessCode,
  //         platform: "WEB",
  //         version: "0.2.0",
  //       });
  //       localStorage.removeItem("accessCode");
  //       localStorage.removeItem("token");
  //       localStorage.setItem("accessCode", signinRes.data.accessCode);
  //       localStorage.setItem("token", authRes.data.session);

  //       await dispatch(fetchAccount());
  //       // await dispatch(fetchApiData()).unwrap();
  //       setMiniSidenav(muiDispatch, true);
  //       navigate("/Live-Map");
  //     } else {
  //       alert("Login failed: No access code received.");
  //     }
  //   } catch (err) {
  //     console.error("Login error:", err);
  //     alert("Login failed. Please check your credentials.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <div style={S.wrapper} className="login-wrapper">

      {/* ══════════ LEFT PANEL ══════════ */}
      <div style={S.left} className="login-left">
        <div style={S.gridOverlay} />
        <div style={S.orb1} /><div style={S.orb2} /><div style={S.orb3} />

        {/* Animated SVG road map */}
        <svg style={S.mapBg} viewBox="0 0 600 700" preserveAspectRatio="xMidYMid slice">
          <defs>
            <path id="r1" d="M -60 200 Q 150 180 300 220 Q 420 250 660 230" />
            <path id="r2" d="M -60 400 Q 120 380 250 420 Q 400 450 660 410" />
            <path id="r3" d="M 150 -30 Q 180 150 200 300 Q 220 450 180 730" />
            <path id="r4" d="M 350 -30 Q 370 200 400 350 Q 420 500 380 730" />
            <path id="r5" d="M -60 120 Q 200 140 400 100 Q 500 85 660 110" />
            <path id="r6" d="M 660 400 Q 550 600 450 590 Q 250 570 50 600" />
          </defs>
          <g stroke="rgba(0,201,167,0.18)" strokeWidth="1.5" fill="none">
            <use href="#r1" /><use href="#r2" /><use href="#r3" />
            <use href="#r4" /><use href="#r5" /><use href="#r6" />
          </g>
          <g stroke="rgba(0,201,167,0.08)" strokeWidth="0.8" fill="none">
            <path d="M 0 300 Q 100 310 200 290 Q 350 270 600 320" />
            <path d="M 250 0 Q 260 300 240 700" />
            <path d="M 0 500 Q 300 480 600 520" />
          </g>
          <g fill="rgba(0,201,167,0.3)">
            <circle cx="180" cy="200" r="4" /><circle cx="380" cy="290" r="4" />
            <circle cx="100" cy="430" r="4" /><circle cx="470" cy="150" r="4" />
            <circle cx="260" cy="560" r="4" /><circle cx="520" cy="490" r="4" />
          </g>
          <g fill="rgba(255,255,255,0.03)" stroke="rgba(0,201,167,0.07)" strokeWidth="0.5">
            <rect x="60" y="60" width="40" height="30" rx="2" />
            <rect x="200" y="80" width="30" height="45" rx="2" />
            <rect x="320" y="50" width="55" height="25" rx="2" />
            <rect x="480" y="300" width="35" height="50" rx="2" />
            <rect x="80" y="480" width="50" height="35" rx="2" />
            <rect x="400" y="500" width="45" height="40" rx="2" />
          </g>
          {[
            { path: "M -60 200 Q 150 180 300 220 Q 420 250 660 230", dur: "12s", delay: "0s", bg: "rgba(243,149,7,0.85)", icon: "🚌" },

            { path: "M -60 400 Q 120 380 250 420 Q 400 450 660 410", dur: "16s", delay: "3s", bg: "rgba(0,201,167,0.8)", icon: "🚚" },
            { path: "M -60 120 Q 200 140 400 100 Q 500 85 660 110", dur: "10s", delay: "1s", bg: "rgba(59,130,246,0.85)", icon: "🚑" },
            { path: "M -60 200 Q 150 180 300 220 Q 420 250 660 230", dur: "14s", delay: "6s", bg: "rgba(168,85,247,0.8)", icon: "🚕" },
            { path: "M 660 400 Q 550 600 450 590 Q 250 570 50 600", dur: "18s", delay: "2s", bg: "rgba(14,165,233,0.8)", icon: "⛵" },
            { path: "M 150 -30 Q 180 150 200 300 Q 220 450 180 730", dur: "15s", delay: "4s", bg: "rgba(16,185,129,0.85)", icon: "⚡" },
            { path: "M 350 -30 Q 370 200 400 350 Q 420 500 380 730", dur: "20s", delay: "8s", bg: "rgba(251,146,60,0.85)", icon: "🚛" },
          ].map((v, i) => (
            <g key={i} style={{ offsetPath: `path('${v.path}')`, animation: `movePath ${v.dur} linear ${v.delay} infinite` }}>
              <rect x="-14" y="-10" width="28" height="18" rx="4" fill={v.bg} stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
              <text x="0" y="4" textAnchor="middle" fontSize="11" dominantBaseline="middle">{v.icon}</text>
            </g>
          ))}
        </svg>

        {/* Signal rings */}
        <div style={{ ...S.signalRings, top: "28%", left: "35%" }}>
          {[0, 1, 2].map((i) => <div key={i} style={S.ring(i)} />)}
        </div>
        <div style={{ ...S.signalRings, top: "60%", left: "65%" }}>
          {[0.5, 1.5, 2.5].map((d, i) => <div key={i} style={S.ring(d)} />)}
        </div>

        {/* GPS Pins */}
        <div style={{ ...S.gpsPin(0), top: "26%", left: "33%" }}>
          <div style={S.pinHead("linear-gradient(135deg,#1398DC,#5BC0F0)")}><div style={S.pinDot} /></div>
        </div>
        <div style={{ ...S.gpsPin(1.2), top: "58%", left: "63%" }}>
          <div style={S.pinHead("linear-gradient(135deg,#00c9a7,#00e8c0)")}><div style={S.pinDot} /></div>
        </div>
        <div style={{ ...S.gpsPin(0.6), top: "42%", left: "95%" }}>
          <div style={S.pinHead("linear-gradient(135deg,#3b82f6,#60a5fa)")}><div style={S.pinDot} /></div>
        </div>

        {/* Vehicle dots */}
        {[
          { top: "19%", left: "52%", bg: "rgba(243,149,7,0.2)", delay: 0.3, icon: "🚌" },
          { top: "72%", left: "22%", bg: "rgba(0,201,167,0.2)", delay: 0.8, icon: "🚚" },
          { top: "48%", left: "78%", bg: "rgba(59,130,246,0.2)", delay: 1.5, icon: "🚑" },
          { top: "82%", left: "55%", bg: "rgba(168,85,247,0.2)", delay: 1.8, icon: "⛵" },
        ].map((v, i) => (
          <div key={i} style={{ ...S.vehicleDot, top: v.top, left: v.left }}>
            <div style={S.vdotInner(v.bg, v.delay)}>{v.icon}</div>
          </div>
        ))}

        {/* Route lines */}
        <div style={S.routeLine("30%", "15%", "40%", 0, -5)} />
        <div style={S.routeLine("60%", "20%", "35%", 2, 8)} />
        <div style={S.routeLine("48%", "30%", "30%", 3.5, -3)} />

        {/* Left content */}
        <div style={S.leftContent}>
          <div style={S.brandRow}>
            <div style={S.brandLogo}>
              <img src={mainLogo} alt="Routegrip" style={{ width: 42, height: 42, objectFit: "cover" }} />
            </div>
            <span style={S.brandName}>NAVYTIC</span>
          </div>

          <div style={S.slidesArea}>
            {SLIDES.map((slide, i) => (
              <div key={i} style={S.slide(i === currentSlide, i === exitingSlide)}>
                <div style={S.slideTag}><div style={S.tagDot} />{slide.tag}</div>
                <div style={S.slideTitle}>
                  {slide.title.map((line, j) => (
                    <span key={j} style={S.titleLine(j === slide.highlight)}>{line}</span>
                  ))}
                </div>
                <div style={S.statsRow}>
                  {slide.stats.map((s, j) => (
                    <div key={j} style={S.statPill}><div style={S.statDot} />{s}</div>
                  ))}
                </div>
                <p style={S.slideDesc}>{slide.description}</p>
                <div style={S.featuresRow}>
                  {slide.features.map((f, j) => (
                    <div key={j} style={S.featChip} className="feat-chip-hover">
                      <span style={{ fontSize: 18 }}>{f.icon}</span>{f.label}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div style={S.dotsRow}>
            {SLIDES.map((_, i) => (
              <button key={i} style={S.dotBtn(i === currentSlide)} onClick={() => goSlide(i)} />
            ))}
          </div>

          <div style={S.industryStrip}>
            {INDUSTRY_PILLS.map((p, i) => (
              <span key={i} style={S.indPill} className="ind-pill-hover">{p.icon} {p.label}</span>
            ))}
          </div>
        </div>
      </div>

      {/* ══════════ RIGHT PANEL ══════════ */}
      {/* ══════════ RIGHT PANEL ══════════ */}
      <div style={S.right} className="login-right">
        <div style={S.rightGlow} />
        <div style={S.rightGlow2} />

        {/* ── Form area ── */}
        <div style={S.formInner}>
          <div style={S.portalLabel}>Fleet Management Portal</div>
          <div style={S.loginTitle}>Welcome back</div>
          <div style={S.loginSubtitle}>Sign in to manage your fleet operations</div>

          <form onSubmit={handleLogin}>
            <div style={S.formGroup}>
              <label style={S.formLabel}>Email address</label>
              <div style={S.inputWrap}>
                <span style={S.inputIcon}>✉️</span>
                <input
                  type="email" placeholder="you@company.com" value={email} required
                  onChange={(e) => setEmail(e.target.value)}
                  onFocus={() => setEmailFocused(true)} onBlur={() => setEmailFocused(false)}
                  style={S.input(emailFocused)}
                />
              </div>
            </div>

            <div style={S.formGroup}>
              <label style={S.formLabel}>Password</label>
              <div style={S.inputWrap}>
                <span style={S.inputIcon}>🔒</span>
                <input
                  type={showPassword ? "text" : "password"} placeholder="Enter your password"
                  value={password} required onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => setPassFocused(true)} onBlur={() => setPassFocused(false)}
                  style={{ ...S.input(passFocused), paddingRight: 44 }}
                />
                <IconButton
                  onClick={() => setShowPassword((v) => !v)} edge="end" size="small"
                  style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}
                >
                  {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </IconButton>
              </div>
            </div>

            <div style={S.formRow}>
              <div style={S.rememberWrap} onClick={() => setRememberMe((v) => !v)}>
                <div style={S.checkBox(rememberMe)}>
                  {rememberMe && <span style={{ color: "#fff", fontSize: 10, fontWeight: 700, lineHeight: 1 }}>✓</span>}
                </div>
                <span style={S.rememberLabel}>Remember me</span>
              </div>
              <a href="#" style={S.forgotLink}>Forgot password?</a>
            </div>

            <button type="submit" disabled={loading} style={S.signBtn(loading)} className="sign-btn-hover">
              {loading ? (
                <><span style={{ display: "inline-block", animation: "pulse 1s infinite" }}>⏳</span>Signing in...</>
              ) : "Sign in →"}
            </button>
          </form>

          <div style={S.divider}>
            <div style={S.divLine} />
            <span style={S.divText}>Follow Dhundhoo</span>
            <div style={S.divLine} />
          </div>

          <div style={S.socialRow}>
            {[
              { href: "https://m.facebook.com/routegrip", icon: <FacebookIcon style={{ fontSize: 20, color: "#1877f2" }} />, title: "Facebook" },
              // { href: "https://www.instagram.com/routegrip", icon: <InstagramIcon style={{ fontSize: 20, color: "#E4405F" }} />, title: "Instagram" },
              { href: "https://x.com/routegrip", icon: <XIcon style={{ fontSize: 18, color: "#000" }} />, title: "X" },
            ].map((s) => (
              <a key={s.title} href={s.href} target="_blank" rel="noreferrer"
                style={S.socialBtn} className="social-btn-hover" title={s.title}>
                {s.icon}
              </a>
            ))}
          </div>

          <div style={S.trustBar}>
            <span style={{ fontSize: 20, flexShrink: 0 }}>🔐</span>
            <div style={S.trustText}>
              <strong style={{ color: "#0f1b35", fontWeight: 600 }}>Enterprise-grade security</strong>
              <br />
              Your fleet data is encrypted end-to-end and compliant with global standards.
            </div>
          </div>
        </div>

        {/* ── Footer (pinned to bottom of right panel) ── */}
        <LoginFooter />

        {/* ── WhatsApp Floating Button ── */}

        <a
          href="https://wa.me/917330776253?text=Hello,%20I%20am%20interested%20in%20Routegrip%20Solutions!"
          target="_blank"
          rel="noreferrer"
          title="Chat with us on WhatsApp"
          style={{
            position: "fixed",
            bottom: 28,
            right: 28,
            width: 50,
            height: 50,
            borderRadius: "50%",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 20px rgba(37,211,102,0.45)",
            zIndex: 9999,
            textDecoration: "none",
            animation: "vPulse 2s ease-in-out infinite",
            overflow: "hidden",
          }}
        >
          <img
            src={whatsappIcon}
            alt="WhatsApp"
            style={{
              width: 50,
              height: 50,
              objectFit: "contain",
            }}
          />
        </a>
      </div>

    </div>
  );
}

export default Basic;